/**
 * Created by giga on 9/12/16.
 */
forestServices.factory('m10', function(){

    function cxriliOrFail(cxrili, saxeoba, text){
        if(cxrili){
            return cxrili;
        } else {
            notifications.showError(text + ' არ არის შერჩეული სახეობისთვის: ', saxeoba.label);
            return false;
        }
    }

    var Service = {

        /**
         * Initialization is required for this service.
         *
         * @param {array} sbXisSaxeobas
         * @param {array} bonitetisCxriliItems
         * @param {array} sbMaragisCxrilis
         */
        init : function(sbXisSaxeobas, bonitetisCxriliItems, sbMaragisCxrilis) {
            Service.sbXisSaxeobas = sbXisSaxeobas;
            Service.bonitetisCxriliItems = bonitetisCxriliItems;
            Service.sbMaragisCxrilis = sbMaragisCxrilis;
        },

        /**
         * Keep the number within min and max
         *
         * @param _number
         * @param _min
         * @param _max
         * @returns {number}
         */
        bound : function (_number, _min, _max){
            return Math.max(Math.min(_number, _max), _min);
        },

        /**
         * Keep the number within list of numbers
         *
         * @param {number} number
         * @param {array} list
         * @returns {*|number}
         */
        boundInList : function(number, list){
            return Service.bound(number, _.min(list), _.max(list))
        },

        /**
         * Normalize item properties to assigned tables boundaries.
         *
         * @param item
         */
        boundItemProperties: function(item){

            var saxeoba = Service.getSaxeobaObject(item.saxeoba_id);

            var maragisCxrili = Service.getMaragisCxrili(saxeoba);
            var bonitetisCxrili = Service.getBonitetisCxrili(saxeoba);

            if(maragisCxrili && bonitetisCxrili){
                var simagles =
                    _.intersection(_.pluck(maragisCxrili, 'simagle'),
                    _.pluck(bonitetisCxrili, 'simagle'));

                item.simagle = Service.boundInList(item.simagle, simagles);
            }
        },

        /**
         *
         */
        itemHasAllTables : function(saxeoba_id){

            var saxeoba = Service.getSaxeobaObject(saxeoba_id);

            return Service.getMaragisCxrili(saxeoba)
                && Service.getBonitetisCxrili(saxeoba)
                && Service.getXnovanebisCxrili(saxeoba);
        },

        getMaragisCxrili : function(saxeoba){
            var cxrili = _.where(Service.sbMaragisCxrilis,
                {sb_maragis_cxrili_saxeoba_id : saxeoba.sb_maragis_cxrili_saxeoba_id});

            return cxriliOrFail(cxrili, saxeoba, 'მარაგის ცხრილი');
        },

        getBonitetisCxrili : function(saxeoba){
            var cxrili = _.where(Service.bonitetisCxriliItems,
                {bonitetis_cxrili_id : saxeoba.bonitetis_cxrili_id});

            return cxriliOrFail(cxrili, saxeoba, 'ბონიტეტის ცხრილი');
        },

        getXnovanebisCxrili : function(saxeoba){
            var cxrili = _.where(Service.bonitetisCxriliItems,
                {bonitetis_cxrili_id : saxeoba.bonitetis_cxrili_id});

            return cxriliOrFail(cxrili, saxeoba, 'ხნოვანების ცხრილი');
        },

        /**
         * Get object of saxeoba from its id
         *
         * @param saxeoba_id
         */
        getSaxeobaObject : function (saxeoba_id){
            return _.findWhere(Service.sbXisSaxeobas, {id : saxeoba_id});
        },

        /**
         * Get maragi for particular m10 item.
         *
         * @param item
         * @param sixshire
         * @returns {*}
         */
        getItemMaragi : function(item, sixshire){

            var saxeoba = Service.getSaxeobaObject(item.saxeoba_id);

            var cxrili = _.where(Service.sbMaragisCxrilis,
                {sb_maragis_cxrili_saxeoba_id : saxeoba.sb_maragis_cxrili_saxeoba_id});

            if(cxrili) {

                var maragi = Math.round(sixshire * _.findWhere(cxrili, {simagle: item.simagle}).maragi * item.coef * 0.1);

                /**
                 * We cannot allow maragi to be zero.
                 */

                return maragi < 1 ? 1 : maragi;

            } else {
                $scope.maketi10_item_form.$setValidity(false);
                notifications.showError('მარაგის ცხრილი არ არის შერჩეული.');
                return false;
            }
        },

        /**
         * Create range of floating numbers
         *
         * @param start
         * @param stop
         * @param step
         * @returns {Array}
         */
        range : function (start, stop, step){
            var out = [];

            if(start > stop){
                return out;
            }

            while(start <= stop){

                out.push(start);

                start += step;
            }

            return out;
        },

        /**
         * Check if saxeoba is momcifari on particular age.
         *
         * @param saxeoba
         * @param celi
         * @returns {boolean}
         */
        isMomcifari : function (saxeoba, celi){

            if(!saxeoba.xnovaneba_cxrili){
                notifications.showError('ხნოვანების ცხრილი არ არის შერჩეული.');
                return;
            }

            var sorted = _.sortBy(saxeoba.xnovaneba_cxrili.items, 'from_age');

            var xnovanebaObject;

            for(var i = 0; i < sorted.length; i++){
                if(sorted[i].from_age < celi){
                    xnovanebaObject = sorted[i];
                } else {
                    break;
                }
            }
            console.log('isMomcifari', xnovanebaObject.xnovaneba_jgufi_id > 2);


            return xnovanebaObject.xnovaneba_jgufi_id > 2;
        },

        /**
         * Get momcifari item from iarusi or false
         *
         * @param {maketi10.iarusi} iarusi
         * @returns {*} item|false
         */
        getMomcifari : function (iarusi)
        {
            for(var i=0; i < iarusi.items.length; i++)
            {
                if(iarusi.items[i].celi){

                    var saxeoba = _.findWhere(Service.sbXisSaxeobas, {id : iarusi.items[i].saxeoba_id});

                    if(Service.isMomcifari(saxeoba, iarusi.items[i].celi))
                    {
                        return iarusi.items[i];
                    }
                }
            }

            return false;
        },

        /**
         * Returns priority number for saxeoba if it is special otherwise undefined
         *
         * @param saxeoba_logical_id
         * @returns {number|undefined}
         */
        isSlecialSaxoeba : function (saxeoba_logical_id){

            console.log('saxeoba_logical_id: ', saxeoba_logical_id);

            var specials = [
                //წაბლი
                [205, 206],

                //კაკალი
                [241, 242, 243, 244],

                //მუხა
                [207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217],

                //ცაცხვი
                [225, 226],

                //თელა
                [229, 230],

                //ნეკერჩხალი
                [219, 220],

                //იფანი
                [227, 228],

                //უთხოვარი
                [111],

                //პანტა
                [265, 266],

                //მაჟალო
                [263, 264],

                //წიფელი
                [201, 202]
            ];

            for(var i=0; i < specials.length; i++){

                if(_.contains(specials[i], saxeoba_logical_id)){
                    return i;
                }
            }
        },

        /**
         * Get priority number for non special trees.
         *
         * @param saxeoba_logical_id
         * @returns {number}
         */
        getPriority : function (saxeoba_logical_id){
            var list = [
                [101, 102, 103, 104],
                [105],
                [106],
                [203, 204],
                [249, 250],
                [223, 224],
                [221, 222],
                [269, 270, 271, 272]
            ];

            for(var i=0; i < list.length; i++){
                if(_.contains(list[i], saxeoba_logical_id)){
                    return i;
                }
            }
        },

        /**
         * Determine gabatonebuli iarusi based on its maragi.
         *
         * @param iarusis
         * @returns {*}
         */
        determineGabatonebuliIarusi : function (iarusis){
            /**
             * Add gabatonebuli flag to iarusi, gabatonebuli saxeoba is determined from gabatonebuli saxeoba.
             */
            var gabatonebuli_iarusi = _.max(iarusis, function(iarusi){

                iarusi._isGabatonebuli = false;

                return Service.getIarusiSum(iarusi);
            });

            gabatonebuli_iarusi._isGabatonebuli = true;

            return gabatonebuli_iarusi;
        },

        getIarusiSum : function(iarusi){
            return _.reduce(iarusi.items,
                function (memo, itm) {
                    return memo + (itm.maragi ? parseInt(itm.maragi) : 0);
                }, 0);
        },

        /**
         * Determine gabatonebuli saxeoba depending on its maragi and priority
         * @param items
         * @returns {*}
         */
        determineGabatonebuiSaxeoba : function (iarusis){

            var iarusi = Service.determineGabatonebuliIarusi(iarusis);

            console.log('iarusi.items: ', iarusi.items);

            if(!iarusi.items || _.isEmpty(iarusi.items)){
                return;
            }

            var items = iarusi.items;

            console.log('items: ', items);

            var total = _.reduce(items,
                function(memo, itm){ return memo + parseInt(itm.maragi); }, 0);

            /**
             * Assign _priority number, _maragiCili and _isSpecial
             */
            items = _.map(items, function(el){

                el._maragiCili = Math.round(el.maragi * (el.coef * 0.1) / total);

                var specialIndex = Service.isSlecialSaxoeba(el.saxeoba_id);

                if(specialIndex !== undefined){
                    el._isSpecial = true;
                    el._priority = specialIndex;
                } else {
                    el._priority = Service.getPriority(el.saxeoba_id);
                }

                return el;

            });

            var sortedSpecials = _.sortBy(_.where(items, {_isSpecial : true}), '_maragiCili');
            var largestSpecial = _.last(sortedSpecials);

            if(largestSpecial){
                /**
                 * If cili is more than 40% for special saxoeba then it gets priority
                 * but first we need to check if it is only one with that value
                 */
                if( 40 >= largestSpecial._maragiCili){
                    /**
                     * Check if other item have same max cili
                     * lower number means higher priority
                     */

                    return _.chain(sortedSpecials)
                        .where({_maragiCili : largestSpecial._maragiCili})
                        .sortBy('_priority').first().value();
                }
            }

            var sorted = _.sortBy(items, {_isSpecial : true}, '_maragiCili');
            var largest = _.last(sorted);

            if(largest){

                return _.chain(sorted)
                    .where({_maragiCili : largest._maragiCili})
                    .sortBy('_priority').first().value();
            }

            console.log('Got here');

            /**
             * If reached here there are no items in $scope.userInput.maketi10.items
             */

        },

        /**
         * Determine boniteti of maketi 10 item based on its parameters
         *
         * @param {maketi10.item} item
         */
        determineBoniteti : function (item){

            var saxeoba_id = item.saxeoba_id;

            var saxeoba = _.findWhere(Service.sbXisSaxeobas, {id : saxeoba_id});

            if(saxeoba && saxeoba.bonitetis_cxrili_id){
                var cxrili = _.where(Service.bonitetisCxriliItems,
                    {bonitetis_cxrili_id : saxeoba.bonitetis_cxrili_id});

                if(cxrili){

                    var list = _.where(cxrili, {asaki : item.celi});

                    var boniteti = _.findWhere(list, {simagle : item.simagle});

                    if(!boniteti) {
                        var maxSimagle = _.max(list, function(el){return el.simagle;}).simagle;
                        var minSimagle = _.min(list, function(el){return el.simagle;}).simagle;

                        boniteti = maxSimagle < item.simagle ?
                            _.findWhere(list, {simagle : maxSimagle}) : _.findWhere(list, {simagle : minSimagle});
                    }

                    return boniteti;

                }

                return false;
            }
        },

        /**
         * Sum sixshires of all iarusis and subtract it from
         * total possible sixshire
         *
         * @param iarusis
         * @returns {*|Array}
         */
        getSixshireLeftover : function (iarusis){

            var sixshireSum = _.reduce(iarusis, function(memo, item){ return memo + item.sixshire; }, 0);

            return Service.range(0.1, 1 - sixshireSum, 0.1);
        },

        /**
         * Get sum of coefs for each iarusi in key pair form.
         *
         * @param iarusis
         */
        getIarusiCoefSums : function(iarusis){

            return _.mapObject(iarusis, function(iarus) {
                return _.reduce(
                    iarus.items,
                    function(memo, item){ return memo + parseInt(item.coef); }, 0);
            });
        }

    };

    return Service;
});